import { render, staticRenderFns } from "./UserProfileInfo.vue?vue&type=template&id=7cecd028&scoped=true&"
import script from "./UserProfileInfo.vue?vue&type=script&lang=ts&"
export * from "./UserProfileInfo.vue?vue&type=script&lang=ts&"
import style0 from "./UserProfileInfo.vue?vue&type=style&index=0&id=7cecd028&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cecd028",
  null
  
)

export default component.exports